module.exports = __webpack_public_path__ + "static/media/logo.58f2f2bb.svg";